import styled from "styled-components";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

export const TemplateWrapper = styled.div<{ colormatrix: TemplateColorObject }>`
	width: 430px;
	max-width: 100%;
	margin: 0 auto;
	background: ${({ colormatrix }) => colormatrix.background || "#FAF6EF"};
	font-family: "Georgia", "Times New Roman", serif;
	overflow: hidden;

	.shaded {
		opacity: 0.35;
	}

	/* ─── ORNAMENT HELPERS ─── */
	.ornament-line {
		display: inline-block;
		width: 60px;
		height: 1px;
		background: ${({ colormatrix }) => colormatrix.font.tertiary};
		vertical-align: middle;
		margin: 0 8px;
	}
	.ornament-thin-line {
		display: inline-block;
		width: 40px;
		height: 1px;
		background: ${({ colormatrix }) => colormatrix.font.tertiary};
		vertical-align: middle;
		margin: 0 10px;
	}
	.ornament-diamond {
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		font-size: 9px;
		vertical-align: middle;
		letter-spacing: 2px;
	}

	/* ─── SECTION 01 ─── */
	.section_01 {
		position: relative;
		background: ${({ colormatrix }) => colormatrix.main};
		min-height: 580px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 24px 50px;
		text-align: center;
		overflow: hidden;
	}
	.section_01::before {
		content: "";
		position: absolute;
		inset: 14px;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary}55;
		pointer-events: none;
		z-index: 1;
	}
	.s01-crown-ornament {
		display: flex;
		align-items: center;
		margin-bottom: 18px;
		z-index: 2;
	}
	.section_01 .wedding_of {
		font-size: 12px;
		letter-spacing: 4px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		margin: 0 0 24px;
		font-family: "Georgia", serif;
		z-index: 2;
	}
	.s01-main-image-frame {
		position: relative;
		width: 260px;
		height: 320px;
		margin: 0 auto 28px;
		z-index: 2;
	}
	.s01-main-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 2px;
		display: block;
		transition: brightness 0.3s;
	}
	.s01-main-image:hover {
		brightness: 1.08;
	}
	.s01-image-overlay {
		position: absolute;
		inset: 0;
		border: 2px solid ${({ colormatrix }) => colormatrix.font.tertiary}80;
		pointer-events: none;
		border-radius: 2px;
	}
	.s01-names-block {
		z-index: 2;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 16px;
	}
	.section_01 .groom_name,
	.section_01 .bride_name {
		font-size: 38px;
		font-weight: 400;
		color: #fff;
		margin: 0;
		letter-spacing: 2px;
		font-family: "Georgia", "Palatino Linotype", serif;
		line-height: 1.2;
	}
	.s01-names-divider {
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		font-size: 22px;
		margin: 4px 0;
		letter-spacing: 2px;
	}
	.s01-date-band {
		display: flex;
		align-items: center;
		z-index: 2;
		margin: 10px 0 20px;
	}
	.section_01 .date {
		font-size: 16px;
		letter-spacing: 3px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		margin: 0;
		white-space: nowrap;
	}
	.section_01 .save_date_text {
		font-size: 13px;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		letter-spacing: 2px;
		margin: 0 0 20px;
		font-style: italic;
		z-index: 2;
	}
	.s01-save-btn {
		z-index: 2;
	}
	.section_01 button {
		background: transparent !important;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary} !important;
		color: ${({ colormatrix }) => colormatrix.font.tertiary} !important;
		letter-spacing: 3px;
		font-size: 11px;
		text-transform: uppercase;
		padding: 10px 28px !important;
		border-radius: 0 !important;
		transition:
			background 0.3s,
			color 0.3s;
		cursor: pointer;
	}
	.section_01 button:hover {
		background: ${({ colormatrix }) => colormatrix.font.tertiary} !important;
		color: ${({ colormatrix }) => colormatrix.main} !important;
	}

	/* ─── SECTION 02 ─── */
	.section_02 {
		background: ${({ colormatrix }) => colormatrix.secondaryBackground || "#F0E8D8"};
		padding: 44px 20px;
		text-align: center;
		border-bottom: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary}40;
	}
	.s02-inner {
		display: flex;
		justify-content: center;
	}
	.section_02 .counter_boxes_wrapper {
		display: flex;
		gap: 12px;
		justify-content: center;
	}
	.section_02 .counter_box_wrapper {
		background: ${({ colormatrix }) => colormatrix.main} !important;
		border-radius: 2px !important;
		color: #fff !important;
		min-width: 64px;
		padding: 12px 8px;
	}

	/* ─── SECTION 03 ─── */
	.section_03 {
		background: ${({ colormatrix }) => colormatrix.background};
		padding: 52px 24px 40px;
		text-align: center;
	}
	.s03-islamic-dua {
		font-family: "Scheherazade New", "Traditional Arabic", serif;
		font-size: 18px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 0 0 28px;
		line-height: 1.9;
		direction: rtl;
	}
	.s03-top-ornament {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 28px;
	}
	.s03-intro {
		font-size: 15px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		line-height: 1.8;
		margin: 0 0 10px;
		font-style: italic;
		letter-spacing: 0.3px;
	}
	.s03-sub-intro {
		font-size: 13px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		letter-spacing: 0.5px;
		line-height: 1.7;
		margin: 0 0 36px;
	}
	.s03-partners {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		gap: 0;
		margin-top: 24px;
	}
	.s03-partner-card {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 12px;
	}
	.s03-partner-img-frame {
		width: 130px;
		height: 160px;
		overflow: hidden;
		border-radius: 1px;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary}70;
		margin-bottom: 14px;
	}
	.s03-partner-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 1px;
		transition:
			transform 0.4s ease,
			brightness 0.3s;
		display: block;
	}
	.s03-partner-img:hover {
		transform: scale(1.04);
		filter: brightness(1.05);
	}
	.s03-partner-name {
		font-size: 20px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		margin: 0 0 8px;
		font-family: "Georgia", serif;
		letter-spacing: 1px;
	}
	.s03-divider-vertical {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 60px 4px 0;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		font-size: 20px;
	}

	/* ─── SECTION 04 ─── */
	.section_04 {
		background: ${({ colormatrix }) => colormatrix.main};
		padding: 52px 32px;
		text-align: center;
		position: relative;
	}
	.section_04::before {
		content: "";
		position: absolute;
		inset: 12px;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary}40;
		pointer-events: none;
	}
	.s04-quran-wrap {
		position: relative;
		z-index: 1;
	}
	.s04-bismillah {
		font-family: "Scheherazade New", "Traditional Arabic", serif;
		font-size: 20px;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		direction: rtl;
		margin: 0 0 18px;
		letter-spacing: 1px;
	}
	.s04-aya {
		font-family: "Scheherazade New", "Traditional Arabic", serif;
		font-size: 17px;
		color: #fff;
		direction: rtl;
		line-height: 2.2;
		margin: 0 0 18px;
		text-align: center;
	}
	.s04-sadaqa {
		font-family: "Scheherazade New", "Traditional Arabic", serif;
		font-size: 16px;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		direction: rtl;
		margin: 0;
	}

	/* ─── SECTION 05 ─── */
	.section_05 {
		background: ${({ colormatrix }) => colormatrix.secondaryBackground || "#F0E8D8"};
		padding: 52px 24px 40px;
	}
	.s05-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 32px;
	}
	.s05-header > span {
		margin-bottom: 10px;
	}
	.s05-title {
		font-size: 20px;
		letter-spacing: 5px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 10px 0 0;
	}
	.s05-story-img-wrap {
		width: 100%;
		max-height: 280px;
		overflow: hidden;
		margin-bottom: 36px;
		border-radius: 2px;
	}
	.s05-story-img {
		width: 100%;
		height: 280px;
		object-fit: cover;
		border-radius: 2px;
		display: block;
		transition: transform 0.4s ease;
	}
	.s05-story-img:hover {
		transform: scale(1.02);
	}
	.s05-timeline {
		display: flex;
		flex-direction: column;
		gap: 0;
		padding: 0 8px;
	}
	.s05-story-item {
		display: flex;
		align-items: flex-start;
		gap: 16px;
		padding: 18px 0;
		border-bottom: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary}30;
	}
	.s05-story-dot {
		width: 10px;
		height: 10px;
		min-width: 10px;
		background: ${({ colormatrix }) => colormatrix.font.tertiary};
		border-radius: 0;
		transform: rotate(45deg);
		margin-top: 5px;
	}
	.s05-story-title {
		font-size: 20px;
		font-weight: 600;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		margin: 0 0 6px;
		letter-spacing: 1px;
		font-family: "Georgia", serif;
	}
	.s05-story-desc {
		font-size: 13px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 0;
		line-height: 1.7;
	}
	.add_story {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50px;
		height: 50px;
		border: 1px dashed ${({ colormatrix }) => colormatrix.font.tertiary};
		margin: 20px auto;
		cursor: pointer;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
	}

	/* ─── SECTION 06 ─── */
	.section_06 {
		background: ${({ colormatrix }) => colormatrix.background};
		padding: 45px 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.s06-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 28px;
		padding: 0 24px;
	}
	.s06-title {
		font-size: 20px;
		letter-spacing: 5px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 10px 0 0;
	}

	/* ─── SECTION 07 ─── */
	.section_07 {
		background: ${({ colormatrix }) => colormatrix.secondaryBackground || "#F0E8D8"};
		padding: 52px 28px 40px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.s07-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 24px;
	}
	.s07-title {
		font-size: 20px;
		letter-spacing: 5px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 10px 0 0;
	}
	.s07-comments-text {
		font-size: 15px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		line-height: 1.8;
		font-style: italic;
		margin: 0 0 10px;
		text-align: center;
	}
	.s07-comments-sub {
		font-size: 12px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		letter-spacing: 1px;
		margin: 0 0 24px;
		text-align: center;
	}

	/* ─── SECTION 08 ─── */
	.section_08 {
		background: ${({ colormatrix }) => colormatrix.background};
		padding: 52px 24px 40px;
		text-align: center;
	}
	.s08-header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 24px;
	}
	.s08-title {
		font-size: 20px;
		letter-spacing: 5px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 10px 0 0;
	}
	.s08-location-text {
		font-size: 14px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		margin: 0 0 20px;
		line-height: 1.7;
		letter-spacing: 0.5px;
	}
	.s08-map-wrap {
		width: 100%;
		border-radius: 2px;
		overflow: hidden;
		margin-bottom: 16px;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.tertiary}40;
	}
	.s08-map-btn {
		margin-bottom: 32px;
	}
	.section_08 button {
		background: ${({ colormatrix }) => colormatrix.main} !important;
		color: ${({ colormatrix }) => colormatrix.button.text} !important;
		border-radius: 0 !important;
		letter-spacing: 3px;
		font-size: 11px;
		text-transform: uppercase;
		padding: 10px 28px !important;
		border: none !important;
		transition: opacity 0.3s;
	}
	.section_08 button:hover {
		opacity: 0.85;
	}
	.s08-conclusion-img-wrap {
		position: relative;
		width: 100%;
		height: 300px;
		margin-bottom: 28px;
		overflow: hidden;
		border-radius: 2px;
	}
	.s08-conclusion-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 2px;
		display: block;
		transition: transform 0.5s ease;
	}
	.s08-conclusion-img-wrap:hover .s08-conclusion-img {
		transform: scale(1.03);
	}
	.s08-conclusion-overlay {
		position: absolute;
		inset: 0;
		background: ${({ colormatrix }) => colormatrix.overlay};
		border-radius: 2px;
	}
	.s08-names-float {
		position: absolute;
		bottom: 28px;
		left: 0;
		right: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		z-index: 2;
	}
	.s08-names-float span {
		font-size: 22px;
		color: #fff;
		font-family: "Georgia", serif;
		letter-spacing: 2px;
	}
	.s08-and {
		font-size: 13px !important;
		color: ${({ colormatrix }) => colormatrix.font.tertiary} !important;
		letter-spacing: 4px !important;
		text-transform: uppercase;
	}
	.s08-conclusion-text {
		font-size: 13px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		line-height: 1.8;
		font-style: italic;
		letter-spacing: 0.5px;
		margin: 0;
	}
`;
